import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { Button, Fade, Typography } from "@mui/material";
import axios from "axios";
import { Link as RouterLink } from "react-router-dom";

const Specialists = ({ specialists, description, loading }) => {
  console.log("description", description);
  const [specialistsData, setSpecialistsData] = useState([]);

  useEffect(() => {
    if (specialists) {
      // Extract specialist IDs from the specialists prop
      const specialistIds = specialists.map(
        (specialist) => specialist.select_specialist
      );

      // Fetch the Specialists where the ID matches those in the specialistIds array
      axios({
        method: "get",
        url: `${
          WP_API_Settings.endpoint
        }wp/v2/theme_specialists?include=${specialistIds.join(
          ","
        )}&acf_format=standard`,
      })
        .then((response) => {
          setSpecialistsData(response.data); // Store the data in state
        })
        .catch((error) => {
          console.error("Error fetching specialists:", error);
        });
    }
  }, [specialists]);

  return (
    <>
      {/* {specialistsData.length>0? */}
      <>
        <Box
          sx={{
            margin: "50px auto",
            maxWidth: "1536px",
            padding: "0 24px",
          }}
        >
          <Typography
            sx={{
              color: "#265DA5",
              textAlign: "center",
              fontSize: "1.5rem",
              fontWeight: "800",
            }}
          >
            {description?.title}
          </Typography>
          <Box
            sx={{
              textAlign: "center",
            }}
            dangerouslySetInnerHTML={{
              __html: description?.content,
            }}
          />
          <Fade in={true} timeout={2000}>
            <Button
              sx={{
                backgroundColor: "#E9531C",
                borderRadius: "50px",
                color: "#ffffff",
                padding: "0.5rem 1rem",
                position: "relative",
                zIndex: "2",
                fontSize: "1rem",
                fontWeight: "600",
                m: "2rem auto",
                display: "table",
                "&:hover": {
                  backgroundColor: "#0C5EAA",
                },
              }}
              component={RouterLink}
              to={"/about/our-people/#team"}
            >
              Meet the Team
            </Button>
          </Fade>
        </Box>

        {/* <Box
                    sx={{
                        display: 'flex',
                        margin: '50px auto',
                        maxWidth: `${theme.width.maxwidth}`,
                        overflow: 'hidden',
                        gap: '20px',
                        flexWrap: {
                            xs: 'wrap',
                            md: 'nowrap',
                        },
                        padding: '0 1rem',
                        justifyContent: 'center',
                    }}
                >
                    {specialistsData && specialistsData.length > 0 && specialistsData.map((specialist, index) => {
                        return (
                            <Box
                                key={index}
                                sx={{
                                    flex: '1 1 auto', // flex-grow: 1, flex-shrink: 1, flex-basis: auto
                                    boxSizing: 'border-box',
                                    marginBottom: '20px',
                                    width: {
                                        xs: '35%',
                                        md: 'unset',
                                    },
                                    maxWidth: '345px',
                                }}
                            >
                                <img src={specialist.acf.profile_picture}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        objectFit: 'cover',
                                    }}
                                />
                                <Box
                                    sx={{
                                        position: 'relative',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: '1.3rem',
                                            fontWeight: '500',
                                            marginTop: '10px',
                                            marginBottom: '5px',
                                            color: '#265DA5',
                                        }}
                                    >
                                        {specialist.title.rendered}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            marginBottom: '5px',
                                        }}
                                    >
                                        {specialist.acf.job_role}
                                    </Typography>
                                    <Typography
                                        onClick={() => window.location.href = `mailto:${specialist.acf.email_address}`}
                                        sx={{
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            color: '#265DA5',
                                        }}
                                    >
                                        Contact {specialist.title.rendered.split(' ')[0]}
                                    </Typography>
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        onClick={() => window.location.href = `mailto:${specialist.acf.email_address}`}
                                        style={{
                                            color: '#E9531C',
                                            position: 'absolute',
                                            right: '0',
                                            top: '5px',
                                            fontSize: '1.3rem',
                                            cursor: 'pointer',
                                        }}
                                    />
                                </Box>
                            </Box>
                        );
                    })}
                </Box> */}
      </>
      {/* : null} */}
    </>
  );
};

export default Specialists;
